<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg4 sm6>          
            <v-card pa-0>                            
              <v-card-text class="">
                <v-form v-model="valid">
                  <v-layout>
                    <v-flex xs4>
                      <v-text-field
                        box
                        label="No"
                        name="no"                              
                        v-model="formModel.no"
                        v-validate="'required'"
                        data-vv-name="no"     
                        v-bind:error-messages="errors.collect('no')"  
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field
                        box
                        label="Akronim"
                        name="akronim"                              
                        v-model="formModel.akronim"
                        v-validate="'required'"
                        data-vv-name="akronim"     
                        v-bind:error-messages="errors.collect('akronim')"  
                        required
                      ></v-text-field>
                    </v-flex>                    
                  </v-layout>
                  
                  <v-text-field
                    box
                    label="Name"
                    name="name"                              
                    v-model="formModel.name"
                    v-validate="'required'"
                    data-vv-name="name"     
                    v-bind:error-messages="errors.collect('name')"  
                    required
                  ></v-text-field>
                  
                  <v-text-field
                    box
                    label="Tagline"
                    name="tagline"                              
                    v-model="formModel.tagline"
                    v-validate="'required'"
                    data-vv-name="tagline"     
                    v-bind:error-messages="errors.collect('tagline')"  
                    required
                  ></v-text-field>
                  
                  <v-switch 
                    v-bind:label="formModel.status === 1 ? 'Status Active' : 'Status Inactive'" 
                    v-bind:true-value="1"
                    v-bind:false-value="0"
                    v-model="formModel.status">                      
                  </v-switch>                                    
                                    
                  <v-textarea
                    box
                    label="Description"                                                  
                    v-model="formModel.desc"                      
                  ></v-textarea> 
                  
                  <slider-picker v-model="colors" style="width:100%" />
                  <v-text-field v-model="formModel.color" label="Color" class="mt-2" solo></v-text-field>
                  
                                                     

                  <div class="form-btn">
                      <v-btn v-if="!isUpdate" @click="save(isUpdate)" color="success">Create</v-btn>
                      <v-btn v-else @click="save(isUpdate)" color="primary">Update</v-btn>                                                                    
                      <v-btn outline @click="clear">Clear</v-btn>
                  </div>                                                                     
                </v-form>  
              </v-card-text>       
            </v-card>
          </v-flex>                   
        </v-layout>
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import Model from '@/apps/frc/models/Partai';    
import {Slider} from 'vue-color';

var model = new Model();

export default {
    components: {
      'slider-picker': Slider,
    },
    $_veeValidate: {
        validator: 'new'
    },    
    data: () => ({
        isEditing:true,
        isUpdate:false,
        formModel: {          
          id : null,
          no : null,
          name : null,
          akronim : null,
          tagline : null,
          desc : null,
          color: '#ffffff',
          status : null,          
        },
        status: [],
        colors:{hex:'#FFFFFF'},
        valid: true
    }),
    watch:{
      formModel:{
        handler(newVal){
          this.colors = {hex:newVal.color};
        },
        deep:true
      },
      colors(newVal){this.formModel.color = newVal.hex;}
    },
    created () {
      
    },    
    mounted () {this.init();}, 
    methods : {
        init(){
            if(this.$route.query.id){
                this.isUpdate  = true;
                model.one({id : this.$route.query.id }).then(data => {                     
                    Object.assign(this.formModel, data === null ? {}:data);                                  
                    this.checking(data);
                });                                               
            }
            
            this.$validator.localize('en', this.dictionary);       
        },
        
        async save(isUpdate = false) {                
            this.$validator.validateAll();    
            this.formModel.time = this.$moment().valueOf();
            this.formModel.info = null;
            if( !this.errors.any() ) {
                var res = isUpdate ? await model.update(this.formModel): await model.create(this.formModel);                
                if(res.status === 200){   
                    this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                
                    this.$router.go(-1);                    
                } else {
                    var title = res.status ? '#'+res.status + ' Oops...' : 'Oops...';
                    var text  = res.statusText ? res.statusText: 'Something happened in setting up the request that triggered an Error.';                     
                    if(res.data){ if(res.data.message){ text += ' ' + res.data.message; } else {this.validate(res.data);}}                
                    this.$swal({type: 'error', title: title, text: text});                    
                }
            }             
        },
       
        validate(data){
            data.forEach( (item) => {
                this.$validator.errors.add({field : item.field,msg : item.message});
            });
        },        
                
        checking(data){
            if(data.info){
                if(data.info.action === 'synch' && data.info.data){
                    this.validate(data.info.data);
                }
            }            
        },        
                
        clear () {
            this.formModel = {};
            this.$validator.reset();
        },
    
        customFilter (item, queryText, itemText) {
            const textOne = item.name.toLowerCase()
            //const textTwo = item.abbr.toLowerCase()
            const searchText = queryText.toLowerCase()

            return textOne.indexOf(searchText) > -1; 
        },                    
    }
}
</script>